import { render, staticRenderFns } from "./Echarts4.vue?vue&type=template&id=1ad1c253&scoped=true&"
import script from "./Echarts4.vue?vue&type=script&lang=js&"
export * from "./Echarts4.vue?vue&type=script&lang=js&"
import style0 from "./Echarts4.vue?vue&type=style&index=0&id=1ad1c253&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad1c253",
  null
  
)

export default component.exports